import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {GameStripeImageComponent} from '../stripe-image/game-stripe-image.component';
import {observer} from 'mobx-react';
import {GameInfo} from '../../../../../services/games/game-info';
import {TrailerBox} from './boxes/trailer/trailer.box';

export interface GameTrailerPreviewComponentProps {
    gameInfo: GameInfo;
}
@observer
export class GameTrailerComponent extends OrbitComponent<GameTrailerPreviewComponentProps> {

    render() {
        let gameInfo = this.props.gameInfo;

        //we used here key={gameInfo.gameType} to make react re render the component when a different gameInfo is provided
        return (
            <TrailerBox key={gameInfo.gameType}>
                <video width={'100%'} poster={gameInfo.stripImage} autoPlay={true} loop={true}>
                    {/*Video source hardcoded for testing purposes*/}
                    <source src={'/assets/videos/harmonium.mp4'} type={"video/mp4"}/>
                    {/*Fallback Image (the browser does not support video)*/}
                    <GameStripeImageComponent gameInfo={this.props.gameInfo}/>
                </video>
            </TrailerBox>
        );
    }
}
